import React, { Suspense } from 'react';
import { getContentType } from 'utils/CloverdotcomEntryUtil';
import { BusyLoader } from 'components/BusyLoader/BusyLoader';
import { LAZY_MODULE_MAP } from './utils';
import { SheetAssemblyItem } from 'api/contentful/contentTypes.cloverdotcom';

// Higher-Order Component to wrap children with Suspense
const DynamicComponentLazyWrapper: React.FC<{ item: SheetAssemblyItem }> = React.memo(
  ({ item: moduleEntry }) => {
    if (!moduleEntry) return null;

    const contentType = getContentType(moduleEntry) ?? '';
    const Component = LAZY_MODULE_MAP[contentType];

    if (!Component) {
      console.warn(`Unrecognized content type ${contentType}`);
      return null;
    }

    return (
      <Suspense fallback={<BusyLoader />}>
        <Component entry={moduleEntry} />
      </Suspense>
    );
  },
);

export default DynamicComponentLazyWrapper;
